import { ArmDisarmState } from "./types";
import { GroupStatus } from "@/store/eventqueue/types";
import { getLocalRegion } from "@/utils/region-utils";

export function getDefaultState(): ArmDisarmState {
	return {
		selectedGroup: null,
		selectedRegion: getLocalRegion(),
		currentTab: GroupStatus.All,
		armDisarmShown: false,
		groupIsArmedModalVisible: false,
		groupIsDisarmedModalVisible: false,
		groupIsOnTestModalVisible: false,
		groupIsOnTestOverride: null
	};
}
